import { useEffect, useState } from 'react';
import {
  getLocalPlayerState,
  subscribeLocalPlayer,
  type LocalPlayerState,
} from '../services/spotifyWebPlayer';

/** Suscripción React al estado del Web Playback SDK. */
export function useSpotifyWebPlayer(): LocalPlayerState {
  const [state, setState] = useState<LocalPlayerState>(() => getLocalPlayerState());
  useEffect(() => subscribeLocalPlayer(setState), []);
  return state;
}
